import { render, staticRenderFns } from "./CounterApp.vue?vue&type=template&id=ab4b7db4"
import script from "./CounterApp.vue?vue&type=script&lang=js"
export * from "./CounterApp.vue?vue&type=script&lang=js"
import style0 from "./CounterApp.vue?vue&type=style&index=0&id=ab4b7db4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports